import React from 'react';
import { LuNavigation, LuNavigationOff, LuCar } from "react-icons/lu";
import { useTranslation } from 'react-i18next';
import styles from './NavigationActionButton.module.css';

// Options for props: size, color, className, style, title
// Available options:
// - size: number | string (e.g., 20 or "2em")
// - color: string (e.g., "red" or "#ff0000")
// - className: string (for external CSS)
// - style: object (standard React style object, e.g., { transform: 'scale(1.1)' })
// - title: string (accessibility tooltip)
const ICONS = {
    cancel: {
        Component: LuNavigationOff,
        props: { size: '1em' }
    },
    drive: {
        Component: LuCar,
        props: { size: '1.2em' }
    },
    navigate: {
        Component: LuNavigation,
        props: { size: '1em' }
    }
};

const NavigationActionButton = ({
    isRoutingMode,
    isDrivingMode,
    hasRoute,
    onToggleRouting,
    onToggleDriving
}) => {
    const { t } = useTranslation();
    const handleClick = (e) => {
        e.preventDefault();
        if (isDrivingMode) {
            onToggleDriving(); // Stop Driving -> Browse
            onToggleRouting(); // Also exit routing mode
        } else if (isRoutingMode) {
            if (hasRoute) {
                onToggleDriving(); // Start Driving
            } else {
                onToggleRouting(); // Cancel -> Browse
            }
        } else {
            onToggleRouting(); // Browse -> Navigate
        }
    };

    const getButtonConfig = () => {
        if (isDrivingMode) {
            return {
                title: t('navigation.cancel'), // Using cancel for now as it stops it.
                icon: ICONS.cancel,
                className: styles.CancelMode
            };
        }
        if (isRoutingMode) {
            if (hasRoute) {
                return {
                    title: t('navigation.drive'),
                    icon: ICONS.drive,
                    className: styles.DriveMode
                };
            }
            return {
                title: t('navigation.cancel'),
                icon: ICONS.cancel,
                className: styles.CancelMode
            };
        }
        return {
            title: t('navigation.navigate'),
            icon: ICONS.navigate,
            className: styles.NavigateMode
        };
    };

    const config = getButtonConfig();
    const { Component, props } = config.icon;

    return (
        <button
            className={`${styles.NavigationActionButton} ${config.className}`}
            title={config.title}
            aria-label={config.title}
            onClick={handleClick}
        >
            <Component {...props} />
            <span>{config.title}</span>
        </button>
    );
};

export default NavigationActionButton;
